function DazWishlist(elem) {
    this.containerElem = $(elem);
    this.productId = this.containerElem.attr('data-wishlist-product');

    this.containerElem.find('.wishlist-add').on('click', $.proxy(this.add, this));
    this.containerElem.find('.wishlist-remove').on('click', $.proxy(this.remove, this));
}

// Slabs toggle add/remove via data-in-wishlist on .slab-card (CSS uses !important).
DazWishlist.register = function (elem) {
    daz.wishlist = daz.wishlist || [];
    const instance = new DazWishlist(elem);
    daz.wishlist.push(instance);
    DazWishlist.ensureUserInfoHook();
    return instance;
};

DazWishlist.ensureUserInfoHook = function () {
    if (DazWishlist._userInfoHook) {
        return;
    }
    DazWishlist._userInfoHook = true;
    daz.api.addCall('User/info', {callbackClass: DazWishlist, callbackFunc: DazWishlist.loadData, onlyLive: true});
};

DazWishlist.prototype.slabCard = function () {
    return this.containerElem.closest('.slab-card');
};

DazWishlist.loadData = function (callData, data, isCache) {
    let wishlistIndex = {};

    for (let i = 0; i < data?.wishlistItems?.length; i++) {
        wishlistIndex[data.wishlistItems[i]] = true;
    }

    for (let i = 0; i < daz.wishlist.length; i++) {
        const id = daz.wishlist[i].productId;
        if (wishlistIndex[id] || wishlistIndex[parseInt(id, 10)]) {
            daz.wishlist[i].setActive();
        } else {
            daz.wishlist[i].setInactive();
        }
    }
};

DazWishlist.prototype.setActive = function () {
    const $card = this.slabCard();
    if ($card.length) {
        $card.attr('data-in-wishlist', 'true');
        return;
    }
    this.containerElem.find('.wishlist-add').hide();
    this.containerElem.find('.wishlist-remove').show();
};

DazWishlist.prototype.setInactive = function () {
    const $card = this.slabCard();
    if ($card.length) {
        $card.attr('data-in-wishlist', 'false');
        return;
    }
    this.containerElem.find('.wishlist-add').show();
    this.containerElem.find('.wishlist-remove').hide();
};

DazWishlist.prototype.syncFilterWishlist = function (inWishlist) {
    if (!daz.filter || !daz.filter.filters || !daz.filter.filters.inWishlist) {
        return;
    }
    if (inWishlist) {
        daz.filter.filters.inWishlist[this.productId] = true;
    } else {
        delete daz.filter.filters.inWishlist[this.productId];
    }
};

DazWishlist.prototype.add = function (event) {
    if (event) {
        event.preventDefault();
        event.stopPropagation();
    }
    if (!daz.api.isLoggedIn()) {
        daz.api.displayErrors(["You must login to add items to your wishlist."]);
        return;
    }
    this.setActive();

    $.ajax('/dazstatic/Wishlist/add/product/' + this.productId, {
        context: this,
        success: this.postAdd,
    });
};

DazWishlist.prototype.postAdd = function (ajaxData) {
    if (ajaxData.success != true) {
        this.setInactive();
        daz.api.displayErrors([ajaxData.message]);
    } else {
        this.syncFilterWishlist(true);
        // GTM stuff
        if (daz?.help && DazProductPage?.productId) {
            const gtmPayload = {
                event: 'add_to_wishlist',
                ecommerce: {
                    items: [
                        {
                            item_id: `${DazProductPage.productId}`
                        }
                    ]
                }
            }

            daz.help.gtmTrigger(gtmPayload)
        }
    }
};

DazWishlist.prototype.remove = function (event) {
    if (event) {
        event.preventDefault();
        event.stopPropagation();
    }
    this.setInactive();

    $.ajax(daz.config.flex_url + 'dazstatic/Wishlist/remove/product/' + this.productId, {
        context: this,
        success: this.postRemove,
    });
};

DazWishlist.prototype.postRemove = function (ajaxData) {
    if (ajaxData.success != true) {
        this.setActive();
        daz.api.displayErrors([ajaxData.message]);
    } else {
        this.syncFilterWishlist(false);
    }
};

$(window).on('beforeDazApi', function () {
    daz.wishlist = [];

    $('.wishlist-buttons').each(function () {
        DazWishlist.register(this);
    });
});
